/**
 * Where the section picker can draw a grid.
 *
 * These are the states whose PLSS sections are in plss_sections_normalized,
 * which is what /api/plss-str-guide serves. Asked by the picker (where to
 * open the map) and by the request form (whether to offer the map at all).
 *
 * TEXAS IS NOT HERE AND CANNOT BE. Texas never went through the Public
 * Land Survey System — land there is described by abstract and survey,
 * not section-township-range — so there is no grid to click. A Texas
 * request is typed, which is what the form has always done.
 */
/**
 * Where the picker's map opens, per state.
 *
 * The ZOOM is the same everywhere and is not a taste call: the PLSS is
 * a uniform grid — a township is six miles square wherever it is — so
 * the zoom that puts a workable number of sections on screen in New
 * Mexico is the same one that does it in Montana.
 *
 * 11.5 puts roughly half a degree across a full-width modal, which is
 * inside the picker's own section-span limit. Opening wider means the
 * map greets you with the township grid and the words "zoom in",
 * which is technically correct and a poor greeting.
 *
 * The CENTRES are where the work is, not the geographic middle — a
 * state centroid at this zoom is a random field.
 */
const PICKER_ZOOM = 11.5;

export const PLSS_STATE_VIEW = Object.freeze({
  NM: { center: [-104.2, 32.6], zoom: PICKER_ZOOM },
  CO: { center: [-104.6, 39.3], zoom: PICKER_ZOOM },
  OK: { center: [-98.5, 35.5], zoom: PICKER_ZOOM },
  WY: { center: [-106.3, 43.0], zoom: PICKER_ZOOM },
  MT: { center: [-109.6, 46.9], zoom: PICKER_ZOOM },
  ND: { center: [-100.5, 47.4], zoom: PICKER_ZOOM },
  KS: { center: [-98.4, 38.5], zoom: PICKER_ZOOM },
  UT: { center: [-111.7, 39.3], zoom: PICKER_ZOOM },
});

export const PICKABLE_STATES = Object.freeze(Object.keys(PLSS_STATE_VIEW));

export function canPickOnMap(state) {
  return PICKABLE_STATES.includes(String(state || '').trim().toUpperCase());
}
